// extracted by mini-css-extract-plugin
module.exports = {"center":"FunctionBlock_style_center__1eD3C","decoration":"FunctionBlock_style_decoration__2RW_1","title":"FunctionBlock_style_title__er0Tq","tip":"FunctionBlock_style_tip__3F8eC"};